module.exports = __webpack_public_path__ + "img/img44.f8d485ea.svg";